<template>
    <div style="margin-top: 2%">
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-subtitle>Enter the details below to verify ACU approval.</v-card-subtitle>
                <v-card-text>
                    <v-text-field
                        v-model="data.opan"
                        v-mask="'X-########'"
                        color="teal"
                        label="Approval Number"
                        :rules="[v=>!!v||'This field is required']"
                        clearable
                        placeholder="C-00000000"
                        @input="formatOpan"
                    />
                    <v-text-field
                        v-model="data.membN"
                        v-mask="'######'"
                        color="teal"
                        label="Member Number"
                        placeholder="000000"
                        :rules="[v=>!!v||'This field is required']"
                        clearable
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        type="submit"
                        color="teal"
                        class="white--text"
                        :loading="loading"
                    >
                        <v-icon>{{ mdiMagnifyScan }}</v-icon>&nbsp;VERIFY ACU APPROVAL
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-dialog
            v-model="showDialog"
            width="500"
            persistent
            class="blackFont"
            style="z-index: 100px;"
        >
            <v-card>
                <v-card-title class="text-h5">
                    <span v-if="isSessionExpired">Session Ended</span>
                    <span v-else>Verification Status</span>
                </v-card-title>
                <v-card-text v-if="isSessionExpired" style="height: auto; min-height: 95px;">
                    <v-fade-transition hide-on-leave>
                        <p style="padding-top: 25px;" class="blackFont">
                            Your session has expired for security reasons. Please <span class="errHighlight">log in again</span> to continue.
                        </p>
                    </v-fade-transition>
                </v-card-text>
                <v-card-text v-else>
                    <v-fade-transition hide-on-leave>
                        <p v-show="invalidOpan&&errMessage&&!loading" class="notFound blackFont">
                            This approval number is <span class="errHighlight">NOT VALID</span>; either it has expired, or it is non-existent. Please check your input.
                        </p>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                        <p v-show="loading" class="loadingNotEligible">
                            <v-progress-linear
                                indeterminate
                                color="#009688"
                            />
                        </p>
                    </v-fade-transition>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        v-if="!isSessionExpired&&!loading&&!invalidOpan"
                        class="txtHighlight"
                        color="error darken-4"
                        text
                        @click="closeModal"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        v-else-if="!isSessionExpired"
                        class="txtHighlight"
                        color="error darken-4"
                        text
                        @click="closeModal"
                    >
                        Close
                    </v-btn>
                    <v-btn
                        v-else
                        class="txtHighlight"
                        color="#009688"
                        text
                        @click="closeModal"
                    >
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mask } from 'vue-the-mask'
import {
    mdiMagnifyScan
} from '@mdi/js'

export default {
    directives: { mask },
    data: ()=>({
        mdiMagnifyScan,
        isAcuApprovalValid: false,
        errMessage: null,
        invalidOpan: false,
        loading: false,
        valid: false,
        data: {
            opan: null,
            membN: null
        }
    }),
    computed: {
        ...mapGetters(['fetchAcuApprovalData', 'isSessionExpired']),
        showDialog: {
            get() {
                return this.isAcuApprovalValid
            },
            set() {
                this.isAcuApprovalValid = false
            }
        }
    },
    watch: {
        fetchAcuApprovalData(newVal) {
            this.loading = false
            if (newVal && newVal.status === 200) {
                this.$emit('isAcuApprovalValid', newVal)
                this.data = {
                    opan: null,
                    membN: null
                }
            } else if (newVal && newVal.status === 406) {
                this.invalidOpan = true
                this.errMessage = newVal.state
                this.isAcuApprovalValid = true
            }
        }
    },
    methods: {
        ...mapActions(['getCsrfToken', 'fetchAcuApproval']),
        closeModal() {
            this.showDialog = false
        },
        formatOpan() {
            if (this.data.opan) {
                let value = this.data.opan.replace(/[^A-Z0-9]/gi, '') // Remove non-alphanumeric characters
                if (value.length > 1) {
                    value = value[0] + '-' + value.slice(1, 9) // Insert '-' after the first character
                }
                this.data.opan = value.toUpperCase() // Ensure uppercase format
            }
        },
        async submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.loading = true
                const params = {
                    MSUU_C: this.$cookies.get('provider_id'),
                    OPAN_N: this.data.opan,
                    MEMB_N: this.data.membN
                }
                this.fetchAcuApproval(params)
            }
        }
    }
}
</script>

<style scoped>
.docInfoBodyNote {
    font-weight: 700;
}
.docInfoBodySubmit {
    padding: 2% 0;
}
.docInfoBodyBtn {
    margin-bottom: 7%;
}
    .loadingNotEligible {
        padding-top: 40px;
    }
    .notFound {
        margin: 0;
        word-spacing: .9px;
        letter-spacing: .5px;
        padding-top: 17px;
    }
    .blackFont {
        color: black;
    }
    .errSearchDoctor {
        padding: 5px 5px 0 5px;
        margin: 0;
    }
    .errHighlight {
        font-weight: 800;
        color: darkred;
    }
    .txtHighlight {
        font-weight: 600;
    }
    .notEligible {
        color: black;
        padding-top: 20px;
    }
</style>

